import React, { useEffect, useState, SyntheticEvent } from 'react'
import styled from 'styled-components/macro'
import {
    ExpiryDateFormat,
    GetApprovalRequest,
    UpdateApproval,
    CreatedDateFormat,
} from './utils'
import LoaderImg from './images/loading.svg'

const ApprovalHeader = styled.div`
    width: 100%;
    float: left;
    display: flex;
    .approval_img {
        width: 36px;
        height: 36px;
        float: left;
        margin-right: 10px;
    }
    .approval_header {
        width: auto;
        float: left;

        h6 {
            font-size: 14px;
            font-family: 'Gordita-Medium';
            color: #000;
            line-height: 14px;
            margin: 0px;
            margin-bottom: 6px;
            text-align: left;
        }
        p {
            font-size: 12px;
            font-family: 'Gordita-Regular';
            color: #000;
            line-height: inherit;
            margin-bottom: 0px;
            text-align: left;
        }
    }
`

export const TextareaV2 = styled.textarea.attrs((boolean: any) => ({
    primary: true,
}))`
    width: 90%;
    float: left;
    padding: 10px 12px 8px 9px;
    border: none;
    border-radius: 6px;
    background: #fff;
    height: 48px !important;
    font-size: 12px;
    font-family: 'Gordita-Regular';
    color: #000000;
    outline: 0;
    resize: none;
    margin-top: 12px;
    overflow: hidden;
`

export const Textarea = styled.textarea.attrs((b: any) => ({
    required: true,
}))`
    width: 100%;
    float: left;
    padding: 35px 12px 8px 12px;
    border: 1px solid #b9b9b9;
    border-radius: 6px;
    background: #fff;
    font-size: 12px;
    font-family: 'Gordita-Regular';
    color: #000000;
    max-height: 100px;
    resize: none;
    outline: 0;

    ${({ activeDropdown }) =>
        activeDropdown &&
        `
border: 1px solid #EB974E;

`}
`
export const InputContent = styled.div<any>`
    color: #999;
    font-size: 12px;
    font-family: 'Gordita-Regular';
    position: absolute;
    pointer-events: none;
    left: 12px;
    top: 18px;
    transition: 0.26s ease-in;
    ${Textarea}:focus ~ &,
    ${Textarea}:not(:placeholder-shown).textarea:not(:focus) ~ .label,
    ${Textarea}:valid ~ & {
        top: 1px;
        font-size: 10px;
        transition: 0.26s ease-out;
        line-height: 10px;
        height: 24px;
        background: #fff;
        width: 95%;
        padding-top: 10px;
    }
    ${TextareaV2}:focus ~ &,
    ${TextareaV2}:not(:placeholder-shown).input:not(:focus) ~ .label,
    ${TextareaV2}:disabled ~ &,
    ${TextareaV2}:valid ~ & {
        top: ${(props) => (props.topContent ? '4px' : '1px')};
        font-size: 10px;
        transition: 0.26s ease-out;
        line-height: 10px;
        background: #fff;
        width: 95%;
        text-align: left;
        height: 12px;
        padding-top: 8px;
`
export const InputWrapper = styled.div`
    width: 100%;
    float: left;
    label {
        width: 24px;
        height: 24px;
        margin: 0px;
        position: absolute;
        right: 20px;
        top: 21px;

        svg {
            width: 24px;
            height: 24px;
        }
    }
`
export const TextareaLength = styled.div`
    float: right;
    font-size: 10px;
    font-family: 'Gordita-Regular';
    color: #000;
    line-height: inherit;
    margin-bottom: 0px;
    text-align: left;
    margin-right: 5px;
`

export const InputContainer = styled.div`
    width: 100%;
    float: left;
    position: relative;
    margin-top: 20px;
`
export const InputContainerForTextArea = styled.div`
    width: 100%;
    float: left;
    position: relative;
    margin-bottom: 20px;
    margin-top: 12px;
    padding-top: 10px;
    border: 1px solid #b9b9b9;
    border-radius: 6px;
    :hover {
        outline: 0;
        border: 1px solid #eb974e;
        box-shadow: none;
    }
    :active {
        outline: 0;
        border: 1px solid #eb974e;
        box-shadow: none;
    }
`

const ApprovalRow = styled.div`
width:100%;
float:left;
display:grid;
grid-template-columns: 48% 48%;
grid-gap: 17px;
margin-top:20px;

${ApprovalHeader}{
    .approval_header {
        width: 100%;
        float: left;

        h6 {
            font-size: 12px;
            font-family: 'Gordita-Medium';
            color: #000;
            line-height: 12px;
            margin:0px;
            margin-bottom: 10px;
            text-align: left;
        }
        p {
            font-size: 12px;
            font-family: 'Gordita-Regular';
            color: #555555;
            line-height: inherit;
            margin-bottom: 0px;
            text-align: left;
        }
}
`
type AppButtonT = {
    requested?: boolean
    rejected?: boolean
    approved?: boolean
}
const AppButton = styled.div<AppButtonT>`
    min-width: 64px;
    height: 24px;
    padding: 0px 10px;
    background: #dbffea 0% 0% no-repeat padding-box;
    border-radius: 3px;
    color: #1db75d;
    font-family: 'Gordita-Medium';
    line-height: 12px;
    margin-top: 12px;
    margin-bottom: 20px;
    float: left;
    display: flex;
    align-items: center;
    font-size: 12px;
    justify-content: center;
    ${({ requested }) =>
        requested &&
        `
color:#D86618;
background:#FFF0E5;
`}
    ${({ rejected }) =>
        rejected &&
        `
background:#FFE5E5;
color:#DD4330;
`}
`
type PropT = {
    primary?: boolean
    disable?:boolean
}
const Button = styled.button<PropT>`
    min-width: 90px;
    height: 32px;
    background: ${(props: PropT) => (props.primary ? '#fff' : '#2468f6')};
    border-radius: 18px;
    border: ${(props: PropT) =>
        props.primary ? '1px solid #b9b9b9' : '1px solid #2468f6'};
    outline: 0;
    font-size: 12px;
    padding: 7px 12px;
    font-family: 'Gordita-Medium';
    color: ${(props) => (props.primary ? '#333' : '#fff')};
    margin: 10px 0px;
    cursor: pointer;
    opacity:${(props) => (props.disable ? '0.5' : '1')};
    pointer-events:${(props) => (props.disable ? 'none' : 'all')};

    :hover {
        background: #ffe5d3;
        color: #333;
        border: 1px solid #ffe5d3;
        a {
            color: #333;
        }
    }
    :active {
        background: ${(props) => (props.primary ? '#ffe5d3' : '#ffe5d3')};
        border: ${(props) =>
            props.primary ? '1px solid #eb974e' : '1px solid #eb974e'};
        color: ${(props) => (props.primary ? '#333' : '#ffe5d3')};
    }

    span {
        width: 12px;
        height: 12px;
        float: left;
        margin-right: 6px;
        display: flex;
        align-items: center;
        position: relative;
        top: 0px;
        svg {
            width: 12px;
            height: 12px;
            fill: #333;
            color: #333;
            margin-right: 0px;
        }
    }
    label {
        margin-bottom: 0px;
        position: relative;
        top: 1px;
    }
    a {
        color: #fff;
        text-decoration: none;
    }
`
const WidthContainer = styled.div`
    width: 100%;
    float: left;
    ${Button} {
        margin-bottom: 0px;
    }
`

const ApprovalBgContainer = styled.div`
    width: 540px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 20px;
`

const ApprovalBg = styled.div`
    width: auto;
    float: left;
    padding: 40px;
    // overflow: scroll;
    max-height: calc(100vh - 160px);
`
const CommentsContainer = styled.div`
    width: 100%;
    float: left;
    .approval_header {
        font-size: 12px;
        margin-top: 20px;
        margin-bottom: 10px;
    }
    ${Button} {
        margin-top: 20px;
        :first-child {
            margin-right: 20px;
        }
    }
`
const ApprovalWrapper = styled.section`
    width: 100%;
    position: fixed;
    background: #eff3f6 0% 0% no-repeat padding-box;
    z-index: 1;
    top: 0;
    left: 0;
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top: 80px;
`
const LoaderTag = styled.span`
    width: 100%;
    float: left;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    img {
        width: 120px;
        height: 120px;
        margin-top: -2px;
        animation-name: spin;
        animation-duration: 3s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    }
    @-ms-keyframes spin {
        from {
            -ms-transform: rotate(0deg);
        }
        to {
            -ms-transform: rotate(360deg);
        }
    }
    @-moz-keyframes spin {
        from {
            -moz-transform: rotate(0deg);
        }
        to {
            -moz-transform: rotate(360deg);
        }
    }
    @-webkit-keyframes spin {
        from {
            -webkit-transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(360deg);
        }
    }
    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
`
export type RequestApprovalT = ApprovalPropT & {
    approval_status: string
    comments: string
}
type ApprovalPropT = {
    requestId: string
    approvalId: string
}
type RequesterT = {
    requester_name: string
    requester_email: string
    details_link: string
    details: string
    title: string
    link_description: string
}
export type ApprovalT = {
    id?: string
    approval_status: string
    createdDate: string
    expiry: {
        days: string
        hours?: string
        minutes?: string
    }
}
type PopupT = ApprovalPropT &
    CommentT & {
        requester: RequesterT
        approval: ApprovalT
    }
type CommentT = {
    comments: string
    onChange: (e: SyntheticEvent) => void
}
type CommentsWrapperT = CommentT & {
    onApproval: (e: string) => void
}
export default function Approval(props: any) {
    const { requestId, approvalId } = props.match.params
    console.log(requestId, approvalId)
    const [requester, setRequester] = useState<RequesterT>({
        requester_name: '',
        requester_email: '',
        details: '',
        title: '',
        details_link: '',
        link_description: '',
    })
    const [approval, setApproval] = useState<ApprovalT>({
        approval_status: '',
        createdDate: '',
        expiry: { days: '' },
    })
    const [comments, setComments] = useState<string>('')
    const [loading, setLoading] = useState({ loader: true, error: '' })
    const onCommentChange = (e: SyntheticEvent) => {
        const { value } = e.target as HTMLInputElement
        setComments(value)
    }
    const GetRequestData = (requestId: string, approvalId: string) => {
        return GetApprovalRequest({ requestId, approvalId })
            .then((res) => {
                let { output } = res.data
                console.log(output, 'output')
                setRequester(output.request)
                setApproval(output)
                setComments(output.comments)
                setLoading({ loader: false, error: '' })
            })
            .catch((err) => {
                setLoading({
                    loader: false,
                    error: err.response
                        ? err.response.data.error
                        : 'Something went wrong! Please try again after sometime.',
                })
            })
    }
    useEffect(() => {
        GetRequestData(requestId, approvalId)
    }, [])
    return (
        <>
            {loading.loader ? (
                <LoaderTag>
                    <img src={LoaderImg} />
                </LoaderTag>
            ) : loading.error !== '' ? (
                <ApprovalWrapper>
                    <ApprovalBgContainer>
                        <ApprovalBg>
                            <LoaderTag>
                                <p>{loading.error}</p>
                                {/* <Button
                  primary
                  onClick={() => GetRequestData(requestId, approvalId)}
                >
                  <label style={{ top: "-1px" }}>retry</label>
                </Button> */}
                            </LoaderTag>
                        </ApprovalBg>
                    </ApprovalBgContainer>
                </ApprovalWrapper>
            ) : (
                <ApprovalPopup
                    comments={comments}
                    onChange={onCommentChange}
                    requestId={requestId}
                    approvalId={approvalId}
                    requester={requester}
                    approval={approval}
                />
            )}
        </>
    )
}
export const ApprovalPopup = (props: PopupT) => {
    const { requestId, approvalId, requester, approval, comments, onChange } =
        props
    const toCamelCase = (title: string) =>
        title.substring(0, 1).toUpperCase() + title.substring(1)
    const onApproval = async (approval_status: string) => {
        let data = {
            requestId,
            approvalId,
            approval_status,
            comments,
        }
        await UpdateApproval(data)
        window.location.reload()
    }
    return (
        <ApprovalWrapper>
            <ApprovalBgContainer>
                <ApprovalBg>
                    <ApprovalHeader>
                        <div className="approval_img">
                            <ApprovalIcon />
                        </div>
                        <div className="approval_header">
                            <h6>Approval Request</h6>
                            <p>Request details</p>
                        </div>
                    </ApprovalHeader>
                    <WidthContainer>
                        {approval.approval_status === 'approved' ? (
                            <AppButton approved>
                                {toCamelCase(approval.approval_status)}
                            </AppButton>
                        ) : approval.approval_status ===
                          'waiting_for_approval' ? (
                            <AppButton requested>Requested</AppButton>
                        ) : (
                            <AppButton requested>
                                {toCamelCase(approval.approval_status)}
                            </AppButton>
                        )}
                    </WidthContainer>
                    <ApprovalHeader>
                        <div className="approval_header">
                            <h6>{requester.title}</h6>
                            <p>{requester.details}</p>
                        </div>
                    </ApprovalHeader>
                    <ApprovalRow>
                        <ApprovalHeader>
                            <div className="approval_header">
                                <h6>Requester Name: </h6>
                                <p>{requester.requester_name}</p>
                            </div>
                        </ApprovalHeader>
                        <ApprovalHeader>
                            <div className="approval_header">
                                <h6>Requester Email: </h6>
                                <p>{requester.requester_email}</p>
                            </div>
                        </ApprovalHeader>
                        <ApprovalHeader>
                            <div className="approval_header">
                                <h6>Requested Time: </h6>
                                <p>{CreatedDateFormat(approval.createdDate)}</p>
                            </div>
                        </ApprovalHeader>
                        <ApprovalHeader>
                            <div className="approval_header">
                                <h6>Status: </h6>
                                {approval.approval_status ===
                                'waiting_for_approval' ? (
                                    <p>Requested</p>
                                ) : (
                                    <p>
                                        {toCamelCase(approval.approval_status)}
                                    </p>
                                )}
                            </div>
                        </ApprovalHeader>
                        <ApprovalHeader>
                            <div className="approval_header">
                                <h6>Request Expiry Time:</h6>
                                <p>{ExpiryDateFormat(approval)}</p>
                            </div>
                        </ApprovalHeader>
                    </ApprovalRow>
                    <WidthContainer>
                        {requester.details_link ? (
                            <Button>
                                <a
                                    href={requester.details_link}
                                    target="_blank"
                                >
                                    {requester.link_description
                                        ? requester.link_description
                                        : requester.details_link}
                                </a>
                            </Button>
                        ) : null}
                    </WidthContainer>
                    {approval.approval_status === 'waiting_for_approval' ? (
                        <CommentsWrapper
                            comments={comments}
                            onChange={onChange}
                            onApproval={onApproval}
                        />
                    ) : (
                        comments !== '' && (
                            <ApprovalRow>
                                <ApprovalHeader>
                                    <div className="approval_header">
                                        <h6>Comments: </h6>
                                        <p>{comments}</p>
                                    </div>
                                </ApprovalHeader>
                            </ApprovalRow>
                        )
                    )}
                </ApprovalBg>
            </ApprovalBgContainer>
        </ApprovalWrapper>
    )
}
const CommentsWrapper = ({
    comments,
    onChange,
    onApproval,
}: CommentsWrapperT) => {

   

    return (
        <CommentsContainer>
            <TextareaInput comments={comments} onChange={onChange} />
            <WidthContainer>
                <Button primary disable={comments.length > 1000} onClick={() => onApproval('rejected')}>
                    Reject
                </Button>
                <Button disable={comments.length > 1000} onClick={() => onApproval('approved')}>Approve</Button>
            </WidthContainer>
        </CommentsContainer>
    )
}

const TextareaInput = ({ comments, onChange }: CommentT) => {
    const MIN_TEXTAREA_HEIGHT = '70px'
    const textareaRef: any = React.useRef(null)

    React.useLayoutEffect(() => {
        // Reset height - important to shrink on delete
        textareaRef.current.style.height = 'inherit'
        // Set height
        textareaRef.current.style.height = `${Math.max(
            textareaRef.current.scrollHeight - 22
        )}px`
    }, [comments])

    return (
        <InputContainerForTextArea>
            <TextareaV2
                onChange={onChange}
                rows={1}
                cols={10}
                ref={textareaRef}
                value={comments}
            />

            <InputContent>
                <span>Comments</span>
            </InputContent>
            <TextareaLength> {comments.length}/1000</TextareaLength>
        </InputContainerForTextArea>
    )
}
const ApprovalIcon = () => (
    <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 36 36"
        xmlSpace="preserve"
    >
        <style>{'.s1t1{fill:#d86618}'}</style>
        <g id="Group_12562" transform="translate(-492 -261)">
            <path
                id="Rectangle_1822"
                d="M496 261h28c2.2 0 4 1.8 4 4v28c0 2.2-1.8 4-4 4h-28c-2.2 0-4-1.8-4-4v-28c0-2.2 1.8-4 4-4z"
                fill="#ffe5d3"
            />
            <g id="Group_8860" transform="translate(-368.875 -184.669)">
                <path
                    id="Path_4325"
                    className="s1t1"
                    d="M885.6 468.7v3.1c0 .9-.7 1.6-1.6 1.6h-11c-.9 0-1.7-.7-1.7-1.6v-.1-1.3V458c0-1.5.6-2.1 2.1-2.1h10.4c.9-.1 1.8.5 1.9 1.4v1c.3 1.4-.5 2.4-1.5 3.4v-.6-2.9c0-.6-.1-.7-.7-.7h-9.9c-.6 0-.7.1-.7.7v12.9c0 .6.1.7.7.7h9.9c.4 0 .8-.1.7-.5-.1-.7.2-1.4.8-1.9.1-.3.3-.5.6-.7z"
                />
                <path
                    id="Path_4326"
                    className="s1t1"
                    d="M882.1 466.4l4.7-5.9c.1-.1.2-.3.3-.4.4-.6 1.2-.8 1.8-.4l.1.1c.6.5.7 1.3.2 1.9l-.1.1c-1.1 1.4-2.3 2.9-3.4 4.3-.8 1-1.6 2.1-2.5 3.1-.4.6-1.2.8-1.8.5-.2-.1-.3-.3-.4-.4-.7-.9-1.5-1.7-2.2-2.6-.5-.5-.5-1.3 0-1.9.5-.5 1.3-.5 1.9 0l.2.2c.2.2.4.5.6.7s.4.4.6.7z"
                />
            </g>
        </g>
    </svg>
)
